import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import randomstring from 'uuid/v4';

import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Warninable from './Warninable';
import ProgrammingTree from './DateTimeNodeTree';
import Snackbar from '../../../labels/Snackbar';

import { types, getOrige, getType } from '../../../../const/types.task';

import {
    BlueCloseIcon,
    BlueTickIcon,
    TypeActionIcon,
    TypeBooleanIcon,
    TypeDropdownIcon,
    TypeCalendarIcon,
    TypeCameraIcon,
    TypeFileIcon,
    TypeMultiCheckIcon,
    TypeNumberRealIcon,
    TypeQRCodeIcon,
    TypeSignIcon,
    TypeTempAutoIcon,
    TypeTempIcon,
    TypeTextFixedIcon,
    TypeTextIcon,
    TypeTimeIcon,
    TypeVideoIcon,
    TypeVenueIcon,
    DateTimeIcon
} from '../../../../images/icons/WrapSvg';

const getProgramming = (values) => {
    const json = values.reduce((arr, p) => {
        const progs = p.days.map((t) => {
            return {
                dia: t.day,
                local: p.local,
                fin: null,
            };
        });
        arr = arr.concat(progs);
        return arr;
    }, []);
    return json;
};

const parseProgramacionTree = (table, data, root) => {
    if (!data || !Array.isArray(data)) return [];

    const aux2 = data.reduce((a, r) => {
        const node = r.local === null ? root : table.find((f) => f.id === parseInt(r.local, 10));
        const elements = a.find((f) => f.local === parseInt(r.local, 10));
        let element = [
            {
                id: randomstring(),
                week: r.dia.split(','),
                day: r.dia,
            },
        ];
        const _new = {
            local: parseInt(r.local, 10),
            node: node,
            days: element,
            id: randomstring(),
        };
        if (elements) {
            const toDelete = a.map((e) => e.local).indexOf(parseInt(r.local, 10));
            a.splice(toDelete, 1);

            const index = elements.days.map((e) => e.day).indexOf(r.dia);
            if (index >= 0) {
                let e = elements.days.find((f) => f.day === r.dia);
                elements.days.splice(index, 1);
                elements.days.push(e);
                element = elements.days;
            } else {
                element = [...elements.days].concat(element);
            }
        }
        const add = !elements
            ? _new
            : {
                local: parseInt(r.local, 10),
                node: node,
                days: element,
                id: randomstring(),
            };
        a.push(add);
        return a;
    }, []);
    return aux2;
};

const getCatalogs = (items, entidades) => {
    let found = [];
    if (items !== undefined && items.length > 0) {
        const aux = items.reduce((arr, i) => {
            if (entidades.indexOf(i.entidad) >= 0) {
                arr.push({ codigo: i.codigo, nombre: i.nombre });
            }
            arr = arr.concat(getCatalogs(i.hijos, entidades));
            return arr;
        }, []);
        found = found.concat(aux);
    }
    return found;
};

function searchTree(elements, codigo) {
    let i;
    let result = null;
    for (i = 0; result === null && i < elements.length; i++) {
        if (elements[i].codigo === codigo) {
            result = elements[i];
        }
        if (result === null && elements[i].hijos) result = searchTree(elements[i].hijos, codigo);
    }
    return result;
}

function Format(input, args) {
    return input.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] !== 'undefined' ? args[number] : match;
    });
}

function getWarningMessage(elements, codigo, campo, intl) {
    const found = findElements(elements, codigo, campo);
    if (found && found.length > 0) {
        return Format(intl.formatMessage({ id: 'confirm_modification' }), [found.length]);
    } else {
        return undefined;
    }
}

function findElements(elements, codigo, campo) {
    let i;
    let result = [];
    for (i = 0; result.length === 0 && i < elements.length; i++) {
        if (elements[i].filtro === codigo && elements[i][campo]) {
            result.push(elements[i].nombre);
        }
        if (result.length === 0 && elements[i].hijos)
            result = findElements(elements[i].hijos, codigo, campo);
    }
    return result;
}

const defaultValues = [0, 10, 20, 30, 50, 80];

class AddFieldPopup extends React.Component {
    state = {
        code: randomstring(),
        name: '',
        comment: '',
        catalog: undefined,
        entidad: undefined,
        filter: undefined,
        score: 10,
        type: this.props.type,
        style: '',
        time: undefined,
        disablereadonly: false,
        disablerequired: false,
        required: true,
        readonly: false,
        day_month: false,
        day_week: false,
        day_year: false,
        day: null,
        warningable: undefined,
        searchable: true,
        deactivatable: false,
        disabledeactivatable: false,
        week: [],
        month: [],
        tag: '',
        tags: [],
        programmingTree: [],
        disableScore: false,
        mostrarrango: false,
        historial: false,
        sts: false,
        stsnombre: '',
        stsnumero: 0,
        campoSeguro: false,
        campoInterno: false,
        inverso: false
    };

    constructor(props) {
        super(props);
        this.enterFunction = this.enterFunction().bind(this);

        const { element, info, parentObject, duplicated } = this.props;
        console.log(element);
        if (element) {
            const type = getType(element.tipo, element.estilo);
            this.state = {
                parentID: element.padre,
                code: element.codigo,
                name: element.nombre,
                campoanterior: element.codigo,
                comment: element.descripcion ? element.descripcion : '',
                catalog: element.catalogo ? element.catalogo : undefined,
                entidad: element.entidad ? element.entidad : undefined,
                filter: element.filtro ? element.filtro : undefined,
                filterParent: element.filtro
                    ? searchTree(this.props.data, element.filtro)
                    : undefined,
                score: element.puntuacion,
                type: type,
                style: element.estilo,
                time: undefined,
                disablereadonly: type === types.textfixed,
                disablerequired: type === types.textfixed,
                disableScore:
                    type === types.signature ||
                    type === types.textfixed ||
                    type === types.photo ||
                    type === types.local ||
                    type === types.file ||
                    type === types.date ||
                    type === types.time ||
                    type === types.datetime,
                required: element.obligatorio,
                readonly: element.sololectura,
                day_month: false,
                day_week: false,
                day_year: false,
                day: null,
                searchable: element.buscable,
                warningable: element.alertable,
                mostrarrango: element.mostrarrango,
                disabledeactivatable: parentObject ? parentObject.desactivable : false,
                deactivatable: parentObject
                    ? parentObject.desactivable
                        ? true
                        : element.desactivable
                    : element.desactivable,
                week: [],
                month: [],
                tag: '',
                tags: element.infoadd ? element.infoadd.split(',') : [],
                programmingTree: parseProgramacionTree(
                    info !== undefined ? info.security.locals : [],
                    element.programacion,
                    info.security.hierarchies,
                ),
                duplicated: duplicated,
                historial: element.historial,
                sts: element.sts ? element.sts : false,
                stsnombre: element.stsnombre,
                stsnumero: element.stsnumero,
                campoInterno: element.campoInterno ? element.campoInterno : false,
                campoSeguro: element.campoSeguro ? element.campoSeguro : false,
                inverso: element.inverso ? element.inverso : false
            };
        } else {
            this.state = {
                code: randomstring(),
                parentID: this.props.parentID,
                name: '',
                comment: '',
                catalog: undefined,
                entidad: undefined,
                filter: undefined,
                value: '',
                score: this.props.type !== types.tab && this.props.type !== types.section ? 10 : 0,
                type: this.props.type,
                style: '',
                time: undefined,
                disablereadonly: false,
                disablerequired: false,
                required: true,
                readonly: false,
                day_month: false,
                day_week: false,
                day_year: false,
                day: null,
                searchable: true,
                warningable: undefined,
                mostrarrango: false,
                deactivatable: parentObject ? (parentObject.desactivable ? true : false) : false,
                disabledeactivatable: parentObject ? parentObject.desactivable : false,
                week: [],
                month: [],
                tag: '',
                tags: [],
                programmingTree: [],
                historial: false,
                sts: false,
                stsnombre: '',
                stsnumero: 0,
                campoInterno: false,
                campoSeguro: false,
                inverso: false
            };
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.enterFunction, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.enterFunction, false);
    }

    enterFunction = () => (event) => {
        if (event.keyCode === 13 && this.isCorrect()) {
            this.handleSummit();
        }
    };

    handleSummit = () => {
        const {
            code,
            name,
            type,
            style,
            comment,
            score,
            tags,
            required,
            readonly,
            catalog,
            entidad,
            filter,
            parentID,
            warningable,
            searchable,
            programmingTree,
            deactivatable,
            mostrarrango,
            historial,
            sts,
            stsnombre,
            stsnumero,
            campoInterno,
            campoSeguro,
            inverso
        } = this.state;
        if (this.props.element) {
            const { element } = this.props;
            element.catalogo = catalog;
            element.entidad = entidad;
            element.filtro = filter;
            element.descripcion = comment;
            element.estilo = style;
            element.infoadd = tags.join(',');
            element.nombre = name;
            element.obligatorio = required;
            element.padre = parentID;
            element.puntuacion = score;
            element.sololectura = readonly;
            element.tipo = getOrige(type);
            element.buscable = searchable;
            element.alertable = warningable;
            element.mostrarrango = mostrarrango;
            element.desactivable = deactivatable;
            element.modified = false;
            element.historial = historial;
            element.programacion = getProgramming(programmingTree);
            element.sts = sts;
            element.stsnombre = stsnombre;
            element.stsnumero = sts ? stsnumero ? stsnumero : 1 : undefined;
            element.campoInterno = campoInterno;
            element.campoSeguro = campoSeguro;
            element.inverso = inverso;
            if (!element.status || element.status !== 'NEW') element.status = 'MODIFIED';
            this.props.edit(element);
        } else {
            this.props.add({
                catalogo: catalog,
                entidad: entidad,
                filtro: filter,
                codigo: code,
                descripcion: comment,
                estilo: style,
                infoadd: tags.join(','),
                metadatos: null,
                nombre: name,
                obligatorio: required,
                padre: parentID,
                buscable: searchable,
                alertable: warningable,
                mostrarrango: mostrarrango,
                puntuacion: score,
                sololectura: readonly,
                tipo: getOrige(type),
                desactivable: deactivatable,
                hijos: [],
                nuevo: 'SI',
                historial: historial,
                programacion: getProgramming(programmingTree),
                sts: sts,
                stsnombre: stsnombre,
                stsnumero: sts ? stsnumero ? stsnumero : 1 : undefined,
                campoInterno: campoInterno,
                campoSeguro: campoSeguro,
                inverso: inverso
            });
        }
    };

    handleClick = (score, disabled) => (event) => {
        if (!disabled) this.setState({ score: score });
    };

    handleClickWeek = (time) => (event) => {
        var arr = this.state.week;
        var index = this.state.week.map((d) => d.id).indexOf(time);

        if (index === undefined || index < 0) {
            arr = this.state.week.slice();
            arr.push({ id: time, weeks: [1, 2, 3, 4, 5] });
        } else {
            arr.splice(index, 1);
        }

        this.setState({
            week: arr,
        });
    };

    handleClickDayWeek = (id, day) => (event) => {
        let arr = this.state.week.slice();
        const value = arr.find((d) => d.id === id);
        const index = arr.map((d) => d.id).indexOf(id);
        if (index === undefined || index < 0) {
            arr.push({ id: id, weeks: [day] });
        } else {
            const i = value.weeks.indexOf(day);
            if (i === undefined || i < 0) {
                value.weeks.push(day);
            } else {
                value.weeks.splice(i, 1);
            }
            arr.splice(index, 1);
            if (value.weeks.length > 0) {
                arr.push(value);
            }
        }
        this.setState({
            week: arr,
        });
    };

    handleClickMonth = (day) => (event) => {
        var arr = this.state.month;
        var index = this.state.month.indexOf(day);

        if (index === undefined || index < 0) {
            arr = this.state.month.slice();
            arr.push(day);
        } else {
            arr.splice(index, 1);
        }

        this.setState({
            month: arr,
        });
    };

    handleClickAllWeek = () => (event) => {
        const aux = [1, 2, 3, 4, 5, 6, 7];
        const weeks = aux.map((d) => {
            return { id: d, weeks: [1, 2, 3, 4, 5] };
        });
        this.setState({
            week: weeks,
        });
    };

    handleSeleccion = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChange = (name) => (event) => {
        this.setState({
            [name]: event.target.value.toUpperCase(),
        });
    };

    handleChecked = (name) => (event) => {
        if (name === 'readonly' && event.target.checked) {
            this.setState({ [name]: event.target.checked, score: 0, required: false });
        } else if (name === 'required' && this.state.entidad) {
            this.setState({
                [name]: event.target.checked,
                warningmessage: !event.target.checked
                    ? getWarningMessage(
                        this.props.data,
                        this.state.code,
                        'obligatorio',
                        this.props.intl,
                    )
                    : undefined,
            });
        } else if (name === 'deactivatable' && this.state.entidad) {
            this.setState({
                [name]: event.target.checked,
                warningmessage: !event.target.checked
                    ? getWarningMessage(
                        this.props.data,
                        this.state.code,
                        'desactivable',
                        this.props.intl,
                    )
                    : undefined,
            });
        } else {
            this.setState({ [name]: event.target.checked });
        }
    };

    handleCheckedFuture = (event) => {
        this.setState({ style: this.state.style === 'BLOQUEADO' ? 'NORMAL' : 'BLOQUEADO' });
    };

    handleUpdateProgrammingTree = (tree) => {
        this.setState({ programmingTree: tree });
    };

    handleType = (type, disable) => (event) => {
        if (!disable) {
            switch (type) {
                case types.textfixed:
                    this.setState({
                        disableScore: true,
                        score: 0,
                        type: type,
                        style: '',
                        disablereadonly: true,
                        disablerequired: true,
                        readonly: true,
                        required: false,
                        warningable: undefined,
                        mostrarrango: false,
                        searchable: false,
                    });
                    break;
                case types.action:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: false,
                        type: type,
                        style: 'SINONAC',
                        warningable: false,
                        mostrarrango: false,
                        searchable: true,
                        inverso: false
                    });
                    break;
                case types.boolean:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: false,
                        type: type,
                        style: '',
                        warningable: false,
                        mostrarrango: false,
                        searchable: true,
                        inverso: false
                    });
                    break;
                case types.multioption:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: false,
                        type: type,
                        style: 'SIMPLE',
                        warningable: undefined,
                        mostrarrango: false,
                        searchable: true,
                        catalog: undefined,
                        entidad: undefined,
                        filter: undefined,
                    });
                    break;
                case types.options:
                    this.setState({
                        readonly: false,
                        disableScore: false,
                        type: type,
                        style: 'DESPLEGABLEV',
                        warningable: undefined,
                        mostrarrango: false,
                        searchable: true,
                        catalog: undefined,
                        entidad: undefined,
                        filter: undefined,
                    });
                    break;
                case types.temp:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: false,
                        type: type,
                        style: 'BLUETOOTH',
                        warningable: {},
                        mostrarrango: false,
                        searchable: true,
                        required: true,
                    });
                    break;
                case types.real:
                case types.number:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: false,
                        type: type,
                        style: '',
                        warningable: {},
                        mostrarrango: false,
                        searchable: true,
                        required: true,
                    });
                    break;
                case types.auto:
                    this.setState({
                        readonly: false,
                        disableScore: false,
                        type: type,
                        style: 'AUTOMATICO',
                        warningable: {},
                        mostrarrango: false,
                        searchable: true,
                        required: true,
                    });
                    break;
                case types.date:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: true,
                        score: 0,
                        type: type,
                        style: 'NORMAL',
                        warningable: {},
                        mostrarrango: false,
                        searchable: true,
                    });
                    break;
                case types.datetime:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: true,
                        score: 0,
                        type: type,
                        style: 'NORMAL',
                        warningable: {},
                        mostrarrango: false,
                        searchable: true,
                    });
                    break;
                case types.time:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: true,
                        score: 0,
                        type: type,
                        style: 'NORMAL',
                        warningable: undefined,
                        mostrarrango: false,
                        searchable: true,
                    });
                    break;
                case types.text:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: true,
                        score: 0,
                        type: type,
                        style: '',
                        warningable: undefined,
                        mostrarrango: false,
                        searchable: true,
                        required: false,
                    });
                    break;
                case types.photo:
                case types.file:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: true,
                        score: 0,
                        type: type,
                        style: '',
                        warningable: undefined,
                        mostrarrango: false,
                        searchable: true,
                        required: false,
                    });
                    break;
                default:
                    this.setState({
                        disablereadonly: false,
                        disablerequired: false,
                        readonly: false,
                        disableScore: true,
                        score: 0,
                        type: type,
                        style: '',
                        warningable: undefined,
                        mostrarrango: false,
                        searchable: true,
                    });
                    break;
            }
        }
    };

    handleDateChange = (name) => (date) => {
        this.setState({ [name]: date });
    };

    handleAdd = (event) => {
        if (this.state.tag && this.state.tag.trim()) {
            const value = this.state.tag.trim();
            const arr = [...this.state.tags];
            if (arr.indexOf(value) < 0) {
                arr.push(value);
                this.setState({ tags: arr, tag: '' });
            }
        }
    };

    handleDelete = (data) => () => {
        const arr = [...this.state.tags];
        const toDelete = arr.indexOf(data);
        arr.splice(toDelete, 1);
        this.setState({ tags: arr });
    };

    handleSelect = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSelectFilter = (event) => {
        const filterParent = searchTree(this.props.data, event.target.value);
        const required = filterParent && !filterParent.obligatorio ? false : true;
        const deactivatable = filterParent && !filterParent.desactivable ? false : true;
        this.setState({
            [event.target.name]: event.target.value,
            filterParent: filterParent,
            required: required,
            deactivatable: deactivatable,
        });
    };

    handleWarninable = (value) => {
        this.setState({ warningable: value });
    };

    createTable = (month) => {
        let table = [];
        for (let i = 1; i <= 31; i++) {
            table.push(
                <Grid
                    item
                    xs={1}
                    key={'day_add_month_' + i}
                    onClick={this.handleClickMonth(i)}
                    className={
                        'hand elements_center align_center text_align_center padding_borders ' +
                        (month.indexOf(i) >= 0 ? 'c_white bg_bluish' : '')
                    }
                >
                    <span className={'barlow_regular_small '}>{i}</span>
                </Grid>,
            );
        }
        return table;
    };

    createTableWeek = (week) => {
        const days = [
            'form_week_day_monday',
            'form_week_day_tuesday',
            'form_week_day_wednesday',
            'form_week_day_thursday',
            'form_week_day_friday',
            'form_week_day_saturday',
            'form_week_day_sunday',
        ];
        return (
            <div className="flex_full_column barlow_semibold_label c_bluish elements_center align_center">
                <div className="box">
                    {days.map((d, i) => {
                        const value = week.find((d) => d.id === i + 1);
                        return (
                            <div key={'days-' + i} className="rowwrap">
                                <div
                                    onClick={this.handleClickWeek(i + 1)}
                                    className={
                                        'cell text_align_center hand c_white' +
                                        (value ? ' bg_bluish ' : ' bg_cool_grey')
                                    }
                                >
                                    <FormattedMessage id={d} />
                                </div>
                                <div
                                    onClick={this.handleClickDayWeek(i + 1, 1)}
                                    className={
                                        'cell text_align_center' +
                                        (value && value.weeks.indexOf(1) >= 0
                                            ? ' c_white bg_bluish_25 '
                                            : '')
                                    }
                                >
                                    1
                                </div>
                                <div
                                    onClick={this.handleClickDayWeek(i + 1, 2)}
                                    className={
                                        'cell text_align_center' +
                                        (value && value.weeks.indexOf(2) >= 0
                                            ? ' c_white bg_bluish_25 '
                                            : '')
                                    }
                                >
                                    2
                                </div>
                                <div
                                    onClick={this.handleClickDayWeek(i + 1, 3)}
                                    className={
                                        'cell text_align_center' +
                                        (value && value.weeks.indexOf(3) >= 0
                                            ? ' c_white bg_bluish_25 '
                                            : '')
                                    }
                                >
                                    3
                                </div>
                                <div
                                    onClick={this.handleClickDayWeek(i + 1, 4)}
                                    className={
                                        'cell text_align_center' +
                                        (value && value.weeks.indexOf(4) >= 0
                                            ? ' c_white bg_bluish_25 '
                                            : '')
                                    }
                                >
                                    4
                                </div>
                                <div
                                    onClick={this.handleClickDayWeek(i + 1, 5)}
                                    className={
                                        'cell text_align_center' +
                                        (value && value.weeks.indexOf(5) >= 0
                                            ? ' c_white bg_bluish_25 '
                                            : '')
                                    }
                                >
                                    5
                                </div>
                            </div>
                        );
                    })}
                    <div key="all-days" className="rowwrap">
                        <div
                            onClick={this.handleClickAllWeek()}
                            className={
                                'cell text_align_center hand c_white' +
                                (week.length === 7 ? ' bg_bluish ' : ' bg_cool_grey')
                            }
                        >
                            <FormattedMessage id="form_week_day_all_days" />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    isCorrect = () => {
        const { name, score, type, catalog, entidad } = this.state;
        return (
            name.length > 3 &&
            !isNaN(parseFloat(score)) &&
            isFinite(score) &&
            score >= 0 &&
            ((type !== types.options && type !== types.multioption) || catalog || entidad)
        );
    };

    handleCloseError = () => {
        this.setState({ warningmessage: '' });
    };

    button = (icon, text, type, current, disable = false) => (
        <Grid item xs={3} sm={2}>
            <div
                onClick={this.handleType(type, disable || this.props.see)}
                className={classNames(
                    'margin_left_12 margin_bottom_12 flex_full_column box elements_center align_center padding_borders barlow_regular_small',
                    current === type
                        ? 'bg_bluish c_white hand'
                        : disable || this.props.see
                            ? 'bg_disabled c_white'
                            : 'c_bluish bg_white hand',
                )}
            >
                {icon}
                <FormattedMessage id={text} />
            </div>
        </Grid>
    );

    component = (type, intl) => {
        switch (type) {
            case types.action:
            case types.boolean:
                return (
                    <section className="flex_auto_column">
                        <Divider className={'margin_top_24 margin_bottom_24'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_12 margin_bottom_24">
                            <FormattedMessage id="form_section_advance_options" />
                        </div>
                        <div className="flex_full_row padding_top_24 align_center">
                            <Switch
                                checked={this.state.warningable}
                                onChange={this.handleChecked('warningable')}
                                value="warningable"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_warningable" />
                            </div>
                        </div>
                        <div className="flex_full_row padding_top_24 align_center">
                            <Switch
                                checked={this.state.inverso}
                                onChange={this.handleChecked('inverso')}
                                value="inverso"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_inverso" />
                            </div>
                        </div>
                        <div className="flex_full_row padding_top_24 align_center">
                            <Switch
                                checked={this.state.historial}
                                onChange={this.handleChecked('historial')}
                                value="historial"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_historial" />
                            </div>
                        </div>
                    </section>
                );
            case types.datetime:
            case types.date:
                const disabled = !this.state.warningable || Object.keys(this.state.warningable).length === 0 || (!this.state.warningable.inferior && !this.state.warningable.superior);
                return (
                    <section className="flex_auto_column">
                        <Divider className={'margin_top_24 margin_bottom_24'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_12 margin_bottom_24">
                            <FormattedMessage id="form_section_advance_options" />
                        </div>
                        <div className="flex_full_column padding_top_24">
                            <div className="flex_auto_row">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_searchable_range_date" />
                                </div>
                            </div>
                            <div className="flex_auto_row">
                                <Warninable
                                    blocked={this.state.mostrarrango}
                                    value={this.state.warningable}
                                    onChange={this.handleWarninable}
                                    type={type}
                                />
                            </div>
                        </div>
                        <div className="flex_full_row padding_top_24 align_center">
                            <Switch
                                checked={this.state.style === 'BLOQUEADO' && !disabled}
                                disabled={disabled}
                                onChange={this.handleCheckedFuture}
                                value="BLOQUEADO"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_date_future" />
                            </div>
                        </div>
                    </section>
                );
            case types.number:
            case types.real:
                return (
                    <section className="flex_auto_column">
                        <Divider className={'margin_top_24 margin_bottom_24'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_12 margin_bottom_24">
                            <FormattedMessage id="form_section_advance_options" />
                        </div>
                        <div className="flex_full_column padding_top_24">
                            <div className="flex_auto_row">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_searchable_range" />
                                </div>
                            </div>
                            <div className="flex_auto_row">
                                <Warninable
                                    blocked={this.state.mostrarrango}
                                    value={this.state.warningable}
                                    onChange={this.handleWarninable}
                                    type={type}
                                />
                            </div>
                        </div>
                        <div className="flex_full_row padding_top_24 align_center">


                            <Switch
                                checked={this.state.mostrarrango}
                                onChange={this.handleChecked('mostrarrango')}
                                value="mostrarrango"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_mostrarrango" />
                            </div>

                        </div>
                        <div className="flex_full_row padding_top_24 align_center">
                            <Switch
                                checked={this.state.historial}
                                onChange={this.handleChecked('historial')}
                                value="historial"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_historial" />
                            </div>
                        </div>
                    </section>
                );
            case types.multioption:
                return (
                    <section className="flex_auto_column">
                        <Divider className={'margin_top_24 margin_bottom_24'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_12 margin_bottom_24">
                            <FormattedMessage id="form_section_advance_options" />
                        </div>
                        <div className="flex_full_column width100 padding_top_24 align_center">
                            <div className="flex_auto_row width100">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_name_catalog" />
                                </div>
                            </div>
                            <div className="flex_auto_row width100">
                                <FormControl
                                    required
                                    className={'flex_full width100 barlow_italic c_slate'}
                                >
                                    <InputLabel htmlFor="age-native-simple">
                                        {intl.formatMessage({ id: 'options_field_label' })}
                                    </InputLabel>
                                    <Select
                                        native
                                        disabled={this.props.see}
                                        value={this.state.catalog}
                                        onChange={this.handleSelect}
                                        inputProps={{
                                            name: 'catalog',
                                            id: 'catalog-simple',
                                        }}
                                    >
                                        <option key={randomstring()} value={undefined} />
                                        {this.props.catalogs.map((cat) => {
                                            return (
                                                <option
                                                    key={randomstring()}
                                                    className="upper"
                                                    value={cat.codigo}
                                                >
                                                    {cat.nombre.toUpperCase()}
                                                </option>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </section>
                );
            case types.options:
                const filtros =
                    this.state.entidad && this.props.entities
                        ? this.props.entities.find((i) => i.codigo === this.state.entidad)
                            ? getCatalogs(
                                this.props.data,
                                this.props.entities
                                    .find((i) => i.codigo === this.state.entidad)
                                    .filtros.map((f) => f.codigo),
                            )
                            : []
                        : [];
                return (
                    <section className="flex_auto_column">
                        <Divider className={'margin_top_24 margin_bottom_24'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_12 margin_bottom_24">
                            <FormattedMessage id="form_section_advance_options" />
                        </div>
                        <div className="flex_full_column width100 padding_top_24 align_center">
                            <div className="flex_auto_row width100">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_name_catalog" />
                                </div>
                            </div>
                            <div className="flex_auto_row width100">
                                <FormControl
                                    required
                                    className={'flex_full width100 barlow_italic c_slate'}
                                >
                                    <InputLabel htmlFor="age-native-simple">
                                        {intl.formatMessage({ id: 'options_field_label' })}
                                    </InputLabel>
                                    <Select
                                        native
                                        disabled={!!this.state.entidad || this.props.see}
                                        value={this.state.catalog}
                                        onChange={this.handleSelect}
                                        inputProps={{
                                            name: 'catalog',
                                            id: 'catalog-simple',
                                        }}
                                    >
                                        <option key={randomstring()} value={undefined} />
                                        {this.props.catalogs.map((cat) => {
                                            return (
                                                <option
                                                    key={randomstring()}
                                                    className="upper"
                                                    value={cat.codigo}
                                                >
                                                    {cat.nombre.toUpperCase()}
                                                </option>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="flex_full_column width100 padding_top_24 align_center">
                            <div className="flex_auto_row width100">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_name_entidad" />
                                </div>
                            </div>
                            <div className="flex_auto_row width100">
                                <FormControl
                                    required
                                    className={'flex_full width100 barlow_italic c_slate'}
                                >
                                    <InputLabel htmlFor="age-native-simple">
                                        {intl.formatMessage({ id: 'options_field_label' })}
                                    </InputLabel>
                                    <Select
                                        native
                                        disabled={!!this.state.catalog || this.props.see}
                                        value={this.state.entidad}
                                        onChange={this.handleSelect}
                                        inputProps={{
                                            name: 'entidad',
                                            id: 'entidad-simple',
                                        }}
                                    >
                                        <option key={randomstring()} value={undefined} />
                                        {this.props.entities.map((cat) => {
                                            return (
                                                <option
                                                    key={randomstring()}
                                                    className="upper"
                                                    value={cat.codigo}
                                                >
                                                    {cat.nombre.toUpperCase()}
                                                </option>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="flex_full_column width100 padding_top_24 align_center">
                            <div className="flex_auto_row width100">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_name_filter" />
                                </div>
                            </div>
                            <div className="flex_auto_row width100">
                                <FormControl
                                    required
                                    className={'flex_full width100 barlow_italic c_slate'}
                                >
                                    <InputLabel htmlFor="age-native-simple">
                                        {intl.formatMessage({ id: 'options_field_label' })}
                                    </InputLabel>
                                    <Select
                                        disabled={!this.state.entidad || this.props.see}
                                        native
                                        value={this.state.filter}
                                        onChange={this.handleSelectFilter}
                                        inputProps={{
                                            name: 'filter',
                                            id: 'filter-simple',
                                        }}
                                    >
                                        <option key={randomstring()} value={undefined} />
                                        {filtros.map((cat) => {
                                            return (
                                                <option
                                                    key={randomstring()}
                                                    className="upper"
                                                    value={cat.codigo}
                                                >
                                                    {cat.nombre.toUpperCase()}
                                                </option>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </section>
                );
            case types.auto:
            case types.temp:
                return (
                    <section className="flex_auto_column">
                        <Divider className={'margin_top_24 margin_bottom_24'} />
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_12 margin_bottom_24">
                            <FormattedMessage id="form_section_advance_options" />
                        </div>
                        <div className="flex_full_column padding_top_24">
                            <div className="flex_auto_row">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_warningable" />
                                </div>
                            </div>
                            <div className="flex_auto_row">
                                <Warninable
                                    value={this.state.warningable}
                                    onChange={this.handleWarninable}
                                />
                            </div>
                        </div>
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'options_field_label' })}
                            </InputLabel>
                            <Select
                                native
                                value={this.state.catalog}
                                onChange={this.handleSelect}
                                inputProps={{
                                    name: 'catalog',
                                    id: 'catalog-simple',
                                }}
                                disabled={this.props.see}
                            >
                                <option key={randomstring()} value={undefined} />
                                {this.props.catalogs.map((cat) => {
                                    return (
                                        <option key={randomstring()} value={cat.codigo}>
                                            {cat.nombre}
                                        </option>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        <div className="flex_full_row padding_top_24 align_center">

                            <Switch
                                checked={this.state.historial}
                                onChange={this.handleChecked('historial')}
                                value="historial"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_historial" />
                            </div>
                        </div>
                    </section>

                );
            default:
                return <div />;
        }
    };

    render() {
        const {
            name,
            type,
            comment,
            score,
            disablerequired,
            required,
            disabledeactivatable,
            deactivatable,
            disablereadonly,
            readonly,
            tag,
            tags,
            programmingTree,
            disableScore,
            filterParent,
            warningmessage,
            sts,
            stsnombre,
            stsnumero,
            campoInterno,
            campoSeguro
        } = this.state;
        const { open, onClose, intl, title, see, info } = this.props;
        const stsAvailable = info.security.licencias.some((f) => f.id === 157 && f.activo);
        return (
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen
                className="z_index_dialog"
            >
                <div className={'flex_header'}>
                    <div className={'flex_full_row padding_borders shadow'}>
                        <BlueCloseIcon
                            color="primary"
                            onClick={(e) => onClose(e)}
                            className="margin_right_18 hand"
                        />
                        <span className={'barlowsemicondensed_bold flex_full c_dark_grey_blue '}>
                            {<FormattedMessage id={title} />}
                        </span>
                        {this.isCorrect() && (
                            <BlueTickIcon
                                className="hand"
                                color="primary"
                                onClick={this.handleSummit}
                            />
                        )}
                    </div>
                </div>
                <DialogContent>
                    <div className="flex_full_column margin_top_9">
                        <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24">
                            <FormattedMessage id="form_field_type_label" />
                        </div>
                        <TextField
                            autoFocus
                            id="name"
                            required
                            error={name.length < 4}
                            helperText={
                                name.length === 0
                                    ? intl.formatMessage({ id: 'required' })
                                    : name.length < 4
                                        ? intl.formatMessage({ id: 'min_length_4' })
                                        : ''
                            }
                            label={intl.formatMessage({ id: 'form_field_name' })}
                            className={'flex_full_row upper'}
                            defaultValue={name}
                            onChange={this.handleChange('name')}
                            margin="normal"
                            maxLength="128"
                            inputProps={{
                                maxLength: 128,
                            }}
                        />
                        {type !== 'PESTANA' && type !== 'SECCION' && (
                            <React.Fragment>
                                <TextField
                                    id="comment"
                                    multiline
                                    label={intl.formatMessage({ id: 'form_field_comment' })}
                                    className={'flex_full_row'}
                                    value={comment}
                                    onChange={this.handleChange('comment')}
                                    margin="normal"
                                />
                                <Divider className={'margin_top_18 margin_bottom_12'} />
                                <Grid container className="margin_top_24 elements_center">
                                    {this.button(
                                        <TypeBooleanIcon className="hand" />,
                                        'type_label_boolean',
                                        types.boolean,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeActionIcon className="hand" />,
                                        'type_label_action',
                                        types.action,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeDropdownIcon className="hand" />,
                                        'type_label_options',
                                        types.options,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeMultiCheckIcon className="hand" />,
                                        'type_label_multioption',
                                        types.multioption,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeTextFixedIcon className="hand" />,
                                        'type_label_textfixed',
                                        types.textfixed,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeTextIcon className="hand" />,
                                        'type_label_text',
                                        types.text,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeNumberRealIcon className="hand" />,
                                        'type_label_real',
                                        types.real,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeTimeIcon className="hand" />,
                                        'type_label_time',
                                        types.time,
                                        type,
                                    )}
                                    {this.button(
                                        <DateTimeIcon className="hand" />,
                                        'type_label_datetime',
                                        types.datetime,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeCalendarIcon className="hand" />,
                                        'type_label_date',
                                        types.date,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeVenueIcon className="hand" />,
                                        'type_label_local',
                                        types.local,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeFileIcon className="hand" />,
                                        'type_label_file',
                                        types.file,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeCameraIcon className="hand" />,
                                        'type_label_photo',
                                        types.photo,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeTempIcon className="hand" />,
                                        'type_label_temp',
                                        types.temp,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeTempAutoIcon className="hand" />,
                                        'type_label_tempauto',
                                        types.auto,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeSignIcon className="hand" />,
                                        'type_label_signature',
                                        types.signature,
                                        type,
                                    )}
                                    {this.button(
                                        <TypeVideoIcon className="hand" />,
                                        'type_label_video',
                                        types.video,
                                        type,
                                        true,
                                    )}
                                    {this.button(
                                        <TypeQRCodeIcon className="hand" />,
                                        'type_label_qr',
                                        types.qr,
                                        type,
                                        true,
                                    )}

                                </Grid>
                                {this.component(type, intl)}

                            </React.Fragment>
                        )}
                        <section className="flex_auto_column margin_bottom_12">
                            <Divider className={'margin_top_18 margin_bottom_12'} />
                            <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24 margin_bottom_24">
                                <FormattedMessage id="form_section_basic_options" />
                            </div>
                            <div className="flex_auto_row wrap">
                                <div className="col-xs-12 col-sm-6 col-lg-3 flex_auto_row nowrap padding_top_24 align_center">
                                    <Switch
                                        disabled={
                                            disabledeactivatable ||
                                            // readonly || /* PERMITER EDITAR CUANDO EL CAMPO PERTENECE A UNA REGLA */
                                            (filterParent && !filterParent.desactivable)
                                        }
                                        checked={deactivatable}
                                        onChange={this.handleChecked('deactivatable')}
                                        value="deactivatable"
                                        color="primary"
                                    />
                                    <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                        <FormattedMessage id="form_field_deactivatable" />
                                    </div>
                                </div>
                                {type !== 'PESTANA' && type !== 'SECCION' && (
                                    <React.Fragment>
                                        <div className="col-xs-12 col-sm-6 col-lg-3 flex_auto_row nowrap padding_top_24 align_center">
                                            <Switch
                                                disabled={
                                                    disablerequired ||
                                                    readonly ||
                                                    (filterParent && !filterParent.obligatorio)
                                                }
                                                checked={required}
                                                onChange={this.handleChecked('required')}
                                                value="required"
                                                color="primary"
                                            />
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_must" />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-lg-3 flex_auto_row nowrap padding_top_24 align_center">
                                            <Switch
                                                disabled={disablereadonly || see}
                                                checked={readonly}
                                                onChange={this.handleChecked('readonly')}
                                                value="readonly"
                                                color="primary"
                                            />
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_read_only" />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-lg-3 flex_auto_row nowrap padding_top_24 align_center">
                                            <Switch
                                                checked={this.state.searchable}
                                                onChange={this.handleChecked('searchable')}
                                                value="searchable"
                                                color="primary"
                                            />
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_searchable" />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-lg-3 flex_auto_row nowrap padding_top_24 align_center">
                                            <Switch
                                                checked={campoSeguro}
                                                onChange={this.handleChecked('campoSeguro')}
                                                value="campoSeguro"
                                                color="primary"
                                            />
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_secure" />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-lg-3 flex_auto_row nowrap padding_top_24 align_center">
                                            <Switch
                                                checked={campoInterno}
                                                onChange={this.handleChecked('campoInterno')}
                                                value="campoInterno"
                                                color="primary"
                                            />
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_internal" />
                                            </div>

                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </section>
                        {(stsAvailable &&
                            (type === types.boolean
                            || type === types.action
                            || type === types.real
                            || type === types.temp
                            || type === types.auto
                            || type === types.options
                            || type === types.multioption)) &&
                            <section className="flex_auto_column margin_bottom_12">
                                <Divider className={'margin_top_18 margin_bottom_12'} />
                                <div className={'flex_full_row barlow_semibold padding_top_24 c_dark_grey_blue'} >
                                    {"STS"}
                                </div>
                                <div className="flex_full_row margin_top_32 align_center">
                                    <Switch
                                        name={'sts'}
                                        checked={sts}
                                        onChange={this.handleChecked('sts')}
                                        value="sts"
                                        color="primary"
                                    />
                                    <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                        <FormattedMessage id="visibility_in_sts" />
                                    </div>
                                </div>
                                <TextField
                                    id="stsnombre"
                                    multiline
                                    disabled={!sts}
                                    label={intl.formatMessage({ id: 'visibility_name_public' })}
                                    className={'flex_full_row'}
                                    value={sts ? stsnombre : ''}
                                    onChange={this.handleChange('stsnombre')}
                                    margin="normal"
                                />
                                <div className="flex_full_row margin_top_32 align_center">
                                    <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                        <InputLabel htmlFor="age-native-simple" className="">
                                            {intl.formatMessage({ id: 'visibility_historic_number' })}
                                        </InputLabel>
                                        <Select
                                            native
                                            value={sts ? stsnumero : undefined}
                                            disabled={!sts}
                                            onChange={this.handleChange('stsnumero')}
                                            inputProps={{ name: 'stsnumero', id: 'stsnumero' }}
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            <option key={randomstring()} value={1} > 1 </option>
                                            <option key={randomstring()} value={2} > 2 </option>
                                            <option key={randomstring()} value={3} > 3 </option>
                                            <option key={randomstring()} value={4} > 4 </option>
                                            <option key={randomstring()} value={5} > 5 </option>
                                            <option key={randomstring()} value={6} > 6 </option>
                                            <option key={randomstring()} value={7} > 7 </option>
                                            <option key={randomstring()} value={8} > 8 </option>
                                            <option key={randomstring()} value={9} > 9 </option>
                                            <option key={randomstring()} value={10} > 10 </option>
                                        </Select>
                                    </FormControl>
                                </div>
                            </section>
                        }
                        <section className="flex_auto_column">
                            <Divider className={'margin_top_18 margin_bottom_12'} />
                            <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24 margin_bottom_24">
                                <FormattedMessage id="form_section_tag" />
                            </div>
                            <div className="flex_full_row">
                                <TextField
                                    id="time-picker-dialog"
                                    label={intl.formatMessage({ id: 'tag_field_label' })}
                                    fullWidth
                                    className="margin_bottom_12 padding_top_24"
                                    value={tag}
                                    onChange={this.handleChange('tag')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 1800, //5 min
                                    }}
                                />
                                {
                                    <Fab
                                        size="small"
                                        color="secondary"
                                        aria-label="add"
                                        onClick={this.handleAdd}
                                        className="margin_left_12"
                                    >
                                        <AddIcon />
                                    </Fab>
                                }
                            </div>
                            <div className="wrap padding_top_24">
                                {tags.map((data) => {
                                    return (
                                        <Chip
                                            key={data}
                                            label={data}
                                            onDelete={this.handleDelete(data)}
                                            className="margin_right_12 margin_bottom_12 c_white bg_bluish"
                                        />
                                    );
                                })}
                            </div>
                        </section>
                        <section className="flex_auto_column">
                            <Divider className={'margin_top_18 margin_bottom_12'} />
                            <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24">
                                <FormattedMessage id="form_section_score" />
                            </div>
                            <div className="flex_full_row c_bluish barlow_semibold_label padding_top_24 elements_center">
                                <div className="box display_flex">
                                    <span
                                        className={
                                            'padding_12 shadow_right hand ' +
                                            (disableScore || readonly
                                                ? 'c_white bg_cool_grey box-aux-left'
                                                : score === 0
                                                    ? 'c_white bg_bluish box-aux-left'
                                                    : '')
                                        }
                                        onClick={this.handleClick(0, disableScore || readonly)}
                                    >
                                        N/A
                                    </span>
                                    <span
                                        className={
                                            'padding_12 shadow_right hand ' +
                                            (disableScore || readonly
                                                ? 'c_white bg_cool_grey'
                                                : score === 10
                                                    ? 'c_white bg_bluish'
                                                    : '')
                                        }
                                        onClick={this.handleClick(10, disableScore || readonly)}
                                    >
                                        10
                                    </span>
                                    <span
                                        className={
                                            'padding_12 shadow_right hand ' +
                                            (disableScore || readonly
                                                ? 'c_white bg_cool_grey'
                                                : score === 20
                                                    ? 'c_white bg_bluish'
                                                    : '')
                                        }
                                        onClick={this.handleClick(20, disableScore || readonly)}
                                    >
                                        20
                                    </span>
                                    <span
                                        className={
                                            'padding_12 shadow_right hand ' +
                                            (disableScore || readonly
                                                ? 'c_white bg_cool_grey'
                                                : score === 30
                                                    ? 'c_white bg_bluish'
                                                    : '')
                                        }
                                        onClick={this.handleClick(30, disableScore || readonly)}
                                    >
                                        30
                                    </span>
                                    <span
                                        className={
                                            'padding_12 shadow_right hand ' +
                                            (disableScore || readonly
                                                ? 'c_white bg_cool_grey'
                                                : score === 50
                                                    ? 'c_white bg_bluish'
                                                    : '')
                                        }
                                        onClick={this.handleClick(50, disableScore || readonly)}
                                    >
                                        50
                                    </span>
                                    <span
                                        className={
                                            'padding_12 shadow_right hand ' +
                                            (disableScore || readonly
                                                ? 'c_white bg_cool_grey'
                                                : score === 80
                                                    ? 'c_white bg_bluish'
                                                    : '')
                                        }
                                        onClick={this.handleClick(80, disableScore || readonly)}
                                    >
                                        80
                                    </span>
                                    <span
                                        className={
                                            'padding_12 hand  ' +
                                            (disableScore || readonly
                                                ? 'c_white bg_cool_grey'
                                                : defaultValues.indexOf(score) === -1
                                                    ? 'c_white bg_bluish box-aux'
                                                    : '')
                                        }
                                        onClick={this.handleClick('', disableScore || readonly)}
                                    >
                                        <FormattedMessage id="form_section_others" />
                                    </span>
                                </div>
                            </div>
                            {defaultValues.indexOf(score) === -1 && (
                                <TextField
                                    id="score"
                                    label={intl.formatMessage({ id: 'form_section_tab_score_score' })}
                                    className={'flex_full_row'}
                                    value={score}
                                    onChange={this.handleChange('score')}
                                    margin="normal"
                                    type="number"
                                    inputProps={{ pattern: '[0-9]*' }}
                                />
                            )}
                        </section>
                        <section className="flex_auto_column margin_bottom_24">
                            <Divider className={'margin_top_24 margin_bottom_24'} />
                            <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_12 margin_bottom_24">
                                <FormattedMessage id="form_section_schedule" />
                            </div>
                            <ProgrammingTree
                                tree={this.props.info.security.hierarchies}
                                programmingTree={programmingTree}
                                onChange={this.handleUpdateProgrammingTree}
                                showTime={false}
                            />
                        </section>
                    </div>
                    {warningmessage && (
                        <Snackbar
                            open={true}
                            variant="warning"
                            text={warningmessage}
                            onClose={this.handleCloseError.bind(this)}
                        />
                    )}
                </DialogContent>
            </Dialog>
        );
    }
}

AddFieldPopup.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        catalogs: state.catalogs,
        info: state.info,
    };
};

export default connect(
    mapStateToProps,
    null,
)(injectIntl(AddFieldPopup));



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/AddField.js